import { render } from "./VideoViewStats.vue?vue&type=template&id=24a0279e"
import script from "./VideoViewStats.vue?vue&type=script&lang=js"
export * from "./VideoViewStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__